module.exports = __webpack_public_path__ + "static/media/import_animated.905734fd.gif";